module.exports = __webpack_public_path__ + "02_medium_black.7813c6c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/02_medium_black.png
// module id = ZH4x
// module chunks = 0